import React from 'react'
import ReactEcharts from 'echarts-for-react';



export default function TopLinesChart({tooltip, grid, legend, data, name, barWidth, itemStyle, label, min, max, interval,yaxis=true, yaxisLabel, yaxisLine, yAxisName, yAxisNameGap, yAxisNamePosition, yaxisSplitlines, xaxisLabel, xaxisTick, xAxisName, xAxisNamePosition, xAxisNameGap, xaxisLine, xaxisdata,Zoom=false}) {

    const  option = {
        tooltip:tooltip,
        grid: grid,
        legend: legend,
    //    legend:{
    //     show:false,
    //     top: 'bottom',
    //     left: 'start',
    //     padding:[0,0,5,20],
    //     itemGap: 4,
    //     itemWidth: 7,
    //     itemHeight: 7,
    //     data: ['Shipping', 'Avg Per Month'],
    //     textStyle: {
    //       color: '#828A91',
    //       fontSize: 8
    //     }
    //   },
        xAxis: {
            axisLabel:xaxisLabel,
            axisTick:xaxisTick,
            name: xAxisName,
            nameLocation: xAxisNamePosition,
            nameGap: xAxisNameGap,
            type: 'category',
            data: xaxisdata,
            nameTextStyle: {
                color: "#D1D5DB"
            },
            axisLine:xaxisLine,
        },
        yAxis: {
            show: yaxis,
            type: 'value',
            min: min,
            max: max,
            interval: interval,
            axisLabel:yaxisLabel,
            axisLine: yaxisLine,
            name: yAxisName,
            nameLocation: yAxisNamePosition,
            nameGap: yAxisNameGap,
            nameTextStyle: {
                color: '#D1D5DB',
            },
            splitLine:yaxisSplitlines,
        },
        // dataZoom: Zoom ? [{
        //     type:'slider',
        //     xAxisIndex: 0,
        //     zoomLock: true,
        //     start: 0,
        //     end: 1 / data?.length * 100,
        //     height: 5,
        //     bottom: 0,
        // }] : [],
        series: [
          {
            name: name,
            data: data,
            type: 'bar',
            barWidth: barWidth,
            itemStyle: itemStyle,
            label: label,
          },

        ]
      };


    return (
        <ReactEcharts
            option={option}
            opts={{renderer:'svg'}}
            style={{ width: '100%', height: '100%' }}
        />
    )
}


